export const getReversedDirection = (dir: 'top' | 'left' | 'bottom' | 'right') => {
    switch (dir) {
        case 'top':
            return 'bottom';
        case 'left':
            return 'right';
        case 'bottom':
            return 'top';
        case 'right':
            return 'left';
    }
};
